import { DeleteUserDeleteRequestModel } from "@/features/user/services/user-model";
import { DeleteUserApi } from "@/features/user/services/delete-user-api";

// 利用者削除画面処理
export class DeleteUserService {
  private deleteUserApi = new DeleteUserApi();

  /**
   * 利用者削除API実行
   */
  public async deleteUser(param: DeleteUserDeleteRequestModel) {
    return await this.deleteUserApi.deleteUser(param);
  }
}
